export default "__VITE_ASSET__CSzOJODp__"